<template>
  <div class="screen background" :style="{ backgroundImage: `url('${introductionBackground}')` }">
    <div class="screen-container">
      <div class="quiz-speech-bubble">
        <vv-speech-bubble
          :title="$t('quiz.quizTime')"
          :subtitle="`${quiz.duration} ${$t('global.minutes')}`"
          >{{ quiz.introduction }}</vv-speech-bubble
        >
      </div>

      <div class="cta">
        <vv-button @click="go">{{ $t('quiz.letsGo') }}</vv-button>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import has from 'lodash/has'
import { mapGetters } from 'vuex'
import { VvButton, VvSpeechBubble } from '@/components/common'
import { NEXT_QUESTION } from '@/store/modules/quiz/types'
import userMixin from '@/mixins/user'

export default {
  name: 'Quiz',
  components: { VvButton, VvSpeechBubble },
  mixins: [userMixin],
  computed: {
    ...mapGetters({ quiz: 'currentQuiz', firebaseId: 'quizFirebaseId' }),
    introductionBackground() {
      if (has(this.quiz, 'introductionBackground.file.url')) {
        return get(this.quiz.introductionBackground, 'file.url')
      }

      return null
    }
  },
  created() {
    this.go()
  },
  methods: {
    go() {
      this.$store.dispatch(NEXT_QUESTION)
    }
  }
}
</script>

<style lang="scss" scoped>
.screen {
  .screen-container {
    .quiz-speech-bubble {
      margin-bottom: 50px;
    }
  }
}

.background {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
